import Vue from 'vue';
import Vuex from 'vuex';
import AuthStore from '@/modules/auth/store/authStore';
import CommonStore from '@/modules/common/store/commonStore';
import AngularStore from '@/modules/angularDelegator/store/angularStore';
import ExternalScriptsStore from '@/modules/externalScripts/store/externalScriptsStore';
import LayoutTopBarStore from '@/modules/layout/topBar/store/layoutTopBarStore';
import BusinessStore from '@/modules/business/store/businessStore';
import BusinessSettingsStore from '@/modules/business/store/businessSettingsStore';
import StaffStore from '@/modules/staff/store/staffStore';
import MainMenuStore from '@/modules/layout/mainMenu/store/mainMenuStore';
import PlatformNavigationStore from '@/modules/layout/platformNavigation/store/platformNavigationStore';
import LayoutBottomNavStore from '@/modules/layout/bottomNav/store/layoutBottomNavStore';
import ToastStore from '@/modules/layout/toast/store/toastStore';
import ConversationStore from '@/modules/conversation/store/conversationStore';
import MessagingStore from '@/modules/messaging/store/messagingStore';
import LayoutStore from '@/modules/layout/store/layoutStore';
import SidePaneStore from '@/modules/sidePane/store/sidePaneStore';
import PaymentsStore from '@/modules/payments/store/paymentsStore';
import InvoicesStore from '@/modules/invoices/store/invoicesStore';
import PaymentRequestStore from '@/modules/paymentRequest/store/paymentRequestStore';
import PaymentSettingsStore from '@/modules/paymentSettings/store/paymentSettingsStore';
import TaxesStore from '@/modules/payments/store/taxesStore';
import MatterStore from '@/modules/matter/store/matterStore';
import ClientStore from '@/modules/client/store/clientStore';
import SystemNotificationStore
  from '@/modules/layout/systemNotifications/store/systemNotificationStore';
import NotificationCenterStore from '@/modules/notificationCenter/store/notificationCenterStore';
import NotificationsSettingsStore from '@/modules/notifications/store/notificationsSettingsStore';
import MobileBottomSheetStore
  from '@/modules/layout/mobileBottomSheet/store/mobileBottomSheetStore';
import QuickActionsStore from '@/modules/layout/quickActions/store/quickActionsStore';
import SearchBarStore from '@/modules/layout/topBar/store/SearchBarStore';
import ModalStore from '@/modules/modals/store/modalStore';
import BizaiStore from '@/modules/bizai/store/bizaiStore';
import SmartReplyStore from '@/modules/bizai/store/smartReplyStore';
import BusinessRulesStore from '@/modules/bizai/store/businessRulesStore';
import AppsStore from '@/modules/app/store/appsStore';
import ViewStore from '@/modules/crm/store/viewStore';
import AiGeneratorStore from '@/modules/aiContentGenerator/store/aiGeneratorStore';
import PosStore from '@/modules/payments/store/posStore';
import ClientPackageStore from '@/modules/clientPackage/store/clientPackageStore';
import ProductOrderStore from '@/modules/productOrder/store/productOrderStore';
import EventAttendanceStore from '@/modules/eventAttendance/store/eventAttendanceStore';
import AppointmentStore from '@/modules/appointment/store/appointmentStore';
import ServicesStore from '@/modules/services/store/servicesStore';
import ProductsStore from '@/modules/products/store/productsStore';
import ImportProductStore from '@/modules/products/store/importProductStore';
import PackagesStore from '@/modules/payments/store/packagesStore';
import CalendarSyncStore from '@/modules/wizards/TwoWaySyncWizard/store/calendarSyncStore';
import SaleStore from '@/modules/payments/store/saleStore';
import WidgetManagerStore from '@/modules/widgetManager/store/widgetManagerStore';
import CallsTextingStore from '@/modules/callsTexting/store/callsTextingStore';
import CallsWidgetStore from '@/modules/widgets/callsWidget/store/callsWidgetStore';
import LeadsWidgetStore from '@/modules/widgets/leadsWidget/store/leadsWidgetStore';
import TextingStore from '@/modules/texting/store/textingStore';
import SubscriptionStore from '@/modules/subscription/store/subscriptionStore';
import BillingStore from '@/modules/billing/store/billingStore';
import AccountStore from '@/modules/account/store/accountStore';
import UsageStore from '@/modules/usage/store/usageStore';
import PurchasableStore from '@/modules/purchasable/store/purchasableStore';
import OfferingStore from '@/modules/purchasable/store/offeringStore';
import AppMarketStore from '@/modules/appMarket/store/appMarketStore';
import ServiceScraperStore from '@/modules/serviceScraper/store/serviceScraperStore';
import ReserveWithGoogleStore from '@/modules/reserveWithGoogle/store/reserveWithGoogleStore';
import CategoriesStore from '@/modules/categories/store/categoriesStore';
import RolesAndPermissionsStore from '@/modules/rolesAndPermissions/store/rolesAndPermissionsStore';
import TodoStore from '@/modules/todo/store/todoStore';
import ResourcesStore from '@/modules/resources/store/resourcesStore';
import CartStore from '@/modules/cart/store/cartStore';
import InitializationContextStore from '@/modules/common/store/InitializationContextStore';
import WebAIWidgetStore from '@/modules/webAIWidget/store/webAIWidgetStore';
import WebAIWidgetChannelsStore from '@/modules/webAIWidget/store/webAIWidgetChannelsStore';
import AiChatStore from '@/modules/aiChat/store/aiChatStore';
import NoteStore from '@/modules/note/store/noteStore';
import PulseStore from '@/modules/pulse/store/pulseStore';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isInitialDataLoaded: false,
    originPage: '',
  },
  getters: {
    isInitialDataLoaded: (state) => state.isInitialDataLoaded,
    originPage: (state) => state.originPage,
  },
  mutations: {
    setIsInitialDataLoaded(state, isInitialDataLoaded) {
      state.isInitialDataLoaded = isInitialDataLoaded;
    },
    setOriginPage(state, originPage) {
      state.originPage = originPage;
    },
  },
  actions: {
    setIsInitialDataLoaded({ commit }, isInitialDataLoaded) {
      commit('setIsInitialDataLoaded', isInitialDataLoaded);
    },
    setOriginPage({ commit }, originPage) {
      commit('setOriginPage', originPage);
    },
  },
  modules: {
    AiGeneratorStore,
    AuthStore,
    CommonStore,
    AngularStore,
    ExternalScriptsStore,
    LayoutTopBarStore,
    BusinessStore,
    BusinessSettingsStore,
    StaffStore,
    MainMenuStore,
    PlatformNavigationStore,
    LayoutBottomNavStore,
    ToastStore,
    ConversationStore,
    MessagingStore,
    LayoutStore,
    SidePaneStore,
    PaymentsStore,
    InvoicesStore,
    PaymentRequestStore,
    PaymentSettingsStore,
    TaxesStore,
    MatterStore,
    ClientStore,
    SystemNotificationStore,
    NotificationCenterStore,
    NotificationsSettingsStore,
    MobileBottomSheetStore,
    QuickActionsStore,
    SearchBarStore,
    ModalStore,
    BizaiStore,
    SmartReplyStore,
    BusinessRulesStore,
    AppsStore,
    ViewStore,
    PosStore,
    ClientPackageStore,
    ProductOrderStore,
    EventAttendanceStore,
    AppointmentStore,
    ServicesStore,
    ProductsStore,
    ImportProductStore,
    PackagesStore,
    CalendarSyncStore,
    SaleStore,
    WidgetManagerStore,
    CallsTextingStore,
    CallsWidgetStore,
    LeadsWidgetStore,
    TextingStore,
    SubscriptionStore,
    BillingStore,
    AccountStore,
    UsageStore,
    PurchasableStore,
    OfferingStore,
    AppMarketStore,
    ReserveWithGoogleStore,
    CategoriesStore,
    RolesAndPermissionsStore,
    CartStore,
    ServiceScraperStore,
    TodoStore,
    ResourcesStore,
    InitializationContextStore,
    WebAIWidgetStore,
    WebAIWidgetChannelsStore,
    AiChatStore,
    NoteStore,
    PulseStore,
  },
});
